<script setup lang="ts">
interface IProps {
  changeText: string;
  content: string | undefined | null;
  disabled?: boolean;
}

interface IEmits {
  (e: "change"): void;
}

const props = defineProps<IProps>();
const emits = defineEmits<IEmits>();
</script>

<template>
  <div
    class="w-full border rounded-lg p-4 flex items-center gap-2"
    :class="{ 'bg-gray-50 text-gray-400': props.disabled }"
  >
    <span class="flex-1 overflow-hidden whitespace-nowrap text-ellipsis">{{ props.content }}</span>

    <button
      class="text-brand p-1 flex items-center gap-2 disabled:text-gray-400"
      :disabled="props.disabled"
      type="button"
      @click.prevent="emits('change')"
    >
      <i class="pi pi-arrow-right-arrow-left" />
      <span class="font-bold">{{ props.changeText }}</span>
    </button>
  </div>
</template>
